module.exports = __webpack_public_path__ + "img/3.9e1241b5.jpg";